/**
 * "Configure the view" engine — per-user, per-browser list-view config for
 * admin modules. See VIEW_CONFIG_PLAN.md at repo root.
 *
 * A List page: declares a `ColumnMeta[]` registry, calls `useViewConfig`,
 * wraps its columns with `applyViewConfig`, reads pageSize/sort from the
 * config, and drops in a `<ConfigureViewButton>` next to Refresh.
 */

export type { ColumnMeta, ViewConfig, ViewConfigDefaults, ViewConfigQuery } from "./types"
export {
  useViewConfig,
  computeDefaultConfig,
  mergeConfig,
  viewConfigEqual,
  viewConfigStorageKey,
  type UseViewConfigResult,
} from "./use-view-config"
export { applyViewConfig, buildQuery, columnScrollX } from "./apply-view-config"
export { ConfigureViewDrawer, type ConfigureViewFeatures } from "./ConfigureViewDrawer"
export { ConfigureViewButton } from "./ConfigureViewButton"
